import React, { useState, useEffect } from 'react';
import { SectionHeader } from './primitives';

// Ranked horizontal bars (top products / top services).
// rows: [{ id, name, value, valueNum, sub }]
export const BarList = ({ title, rows = [], emptyText = 'No sales in this period.', action }) => {
  const top = rows[0] ? rows[0].valueNum : 1;
  const [grown, setGrown] = useState(false);
  useEffect(() => {
    setGrown(false);
    const r = requestAnimationFrame(() => setGrown(true));
    return () => cancelAnimationFrame(r);
  }, [rows]);

  return (
    <div className="cd-card">
      <SectionHeader title={title} action={action} />
      {rows.length === 0 ? (
        <p className="cd-empty">{emptyText}</p>
      ) : (
        <div className="cd-bars-list">
          {rows.map((r) => {
            const pct = Math.max(6, Math.round((r.valueNum / (top || 1)) * 100));
            return (
              <div className="cd-bars-row" key={r.id || r.name}>
                <div className="cd-bars-info">
                  <div className="cd-bars-name">{r.name}</div>
                  {r.sub && <div className="cd-bars-sub">{r.sub}</div>}
                </div>
                <div className="cd-bars-track"><div className="cd-bars-fill" style={{ width: grown ? `${pct}%` : '0%' }} /></div>
                <div className="cd-bars-val">{r.value}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
